export default "__VITE_ASSET__CXIv03fl__"